import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Avatar from "@material-ui/core/Avatar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Hidden from "@material-ui/core/Hidden";
import Badge from "@material-ui/core/Badge";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";

import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import MenuIcon from "@material-ui/icons/Menu";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import LanguageHandler from "../components/LanguageHandler"; //language
import localizationManager from "./localizationManager"; //language
import { MenuItem, Menu } from "@material-ui/core"; //language
import LanguageIcon from "@material-ui/icons/Language"; //language

import logo from "../images/linkchamp_logo_64.png";
import Index from "./index";
import Company from "./company";
import Product from "./product";
import TradeShow from "./tradeShow";
import Inquiry from "./inquiry";
import Contact from "./contact";
import PrivacyPolicy from "./privacyPolicy";
import ScrollToTop from "./scrollToTop";
import NotFound from "./notFound";
import TaiwanInverterManufacturer from "./taiwanInverterManufacturer";
import Footer from "./footer";
import Articles from "./articles";
import ArticleDetail from "./articleDetail";

import {
  withStyles,
  withTheme,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch,
  Redirect,
} from "react-router-dom";

// Helper to get prefix
const getLangPrefix = (lang) => {
  return lang && lang !== "en" ? `/${lang}` : "";
};

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#ffffff",
    },
    secondary: {
      main: "#E44A4B",
    },
  },
});

const styles = {
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  tab: {
    minWidth: 72,
  },
  drawerButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  hide: {
    display: "none",
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: `0 ${theme.spacing.unit * 4}px 0 ${theme.spacing.unit * 2}px`,
    justifyContent: "flex-end",
  },
};

//**********NOTE: the following start/end dates need to be same as tradeShow.jsx
// const tradeShowDetails = [
//   {
//     name: "Taipei AMPA 2024",
//     start: "2024/04/17",
//     end: "2024/04/20",
//   },
//   {
//     name: "Automechanika Frankfurt 2024",
//     start: "2024/09/10",
//     end: "2024/09/14",
//   },
// ];

const redirectURLs = [
  {
    old: "/index-1.htm",
    new: "/",
  },
  {
    old: "/app_com.htm",
    new: "/",
  },
  {
    old: "/da_m_sine_wave.htm",
    new: "/product/sp-series",
  },
  {
    old: "/da_m_sine_wave_hp.htm",
    new: "/product/hp-series",
  },
  {
    old: "/pr_m_sp5000.htm",
    new: "/product/sp-series/sp-5000",
  },
  {
    old: "/pr_da_sp2004_1500c.htm",
    new: "/product/sp-c-series/sp-1500c",
  },
  {
    old: "/sp-600.htm",
    new: "/product/sp-series/sp-600",
  },
  {
    old: "/product/es-series/hp-600usb-eup",
    new: "/product/es-series/es-600usb",
  },
  {
    old: "/product/dc-1224-series/dc1224-35a",
    new: "/product/dc-1224-series/dc1224-50a",
  },
  {
    old: "/product/hp-c-series/hp-1200c",
    new: "/product/hp-c-series/hp-1500c",
  },
  {
    old: "/product/rc-series/rc-ad",
    new: "/product/rc-series/rc-s-ad",
  },
  {
    old: "/product/sp-series/sps-75usb",
    new: "/product/sp-series/sps-150usb",
  },
  {
    old: "/product/sn-series/sn-1000bt",
    new: "/product/sn-bt-series/sn-1000bt",
  },
  {
    old: "/product/sn-series/sn-1500bt",
    new: "/product/sn-bt-series/sn-1500bt",
  },
  {
    old: "/product/sn-series/sn-2000bt",
    new: "/product/sn-bt-series/sn-2000bt",
  },
  {
    old: "/product/sn-series/sn-2500bt",
    new: "/product/sn-bt-series/sn-2500bt",
  },
  {
    old: "/product/sn-series/sn-3000bt",
    new: "/product/sn-bt-series/sn-3000bt",
  },
  {
    old: "/tradeshow",
    new: "/news",
  },
];

class LCAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.cart = {};
    let cartString = localStorage.getItem("inquiryCart");
    if (cartString !== null) {
      this.cart = JSON.parse(cartString);
    }
    this.state = {
      value: false,
      open: false,
      tradeshows: [],
      cartNum: Object.keys(this.cart).length,
      isSnackbarOpen: false,
      dialogOpen: false,
      searchTerm: "",
      anchorEl: null,
      language: localizationManager.currentLang, //language
      forceUpdate: 0,
    };
  }

  componentDidMount() {
    this.fetchNewsData();
    // localizationManager.setupLocalization().then(() => {
    //   this.setState((prev) => ({ forceUpdate: prev.forceUpdate + 1 }));
    // });
  }

  fetchNewsData = async () => {
    try {
      const response = await fetch("/data/news.json");
      if (!response.ok) {
        throw new Error("Network response was not ok.");
      }
      const jsonData = await response.json();
      this.setState({ tradeshows: jsonData.tradeshows });
    } catch (error) {
      console.error("Error fetching news data:", error);
    }
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleChange = (event, value) => {
    this.setState({ value: value });
  };

  handleSnackbarClose = () => {
    this.setState({ isSnackbarOpen: false });
  };

  cartCallback = (item) => {
    if (item.moq === 0) {
      delete this.cart[item.name];
    } else {
      this.cart[item.name] = {
        moq: item.moq,
        img: item.img,
        url: item.url,
        spec: item.spec,
      };
      if (item.isNewAdd) {
        this.setState({ isSnackbarOpen: true });
      }
    }
    this.setState({ cartNum: Object.keys(this.cart).length });
    // console.log(JSON.stringify(this.cart));
    localStorage.setItem("inquiryCart", JSON.stringify(this.cart));
  };

  handleDialogClickOpen = () => {
    this.setState({ dialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ dialogOpen: false });
  };

  handleDialogTextFieldChange = (event) => {
    this.setState({ searchTerm: event.target.value });
  };

  handleClick = (event) => {
    // Open language menu
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = async (lang, history, location) => {
    if (lang) {
      // 1. Save settings
      await localizationManager.setupLocalization(lang);

      // 2. Calculate new path
      const currentPath = location.pathname;
      // Define all possible prefixes to strip
      const knownPrefixes = ["/ja", "/zh-TW", "/zh-tw", "/zh", "/en"];

      let cleanPath = currentPath;
      for (const p of knownPrefixes) {
        if (cleanPath.startsWith(p)) {
          // Verify it's a full segment match (e.g. /ja/ or /ja) to avoid partials if any
          if (cleanPath.length === p.length || cleanPath[p.length] === "/") {
            cleanPath = cleanPath.substring(p.length);
            break;
          }
        }
      }

      // Ensure cleanPath starts with /
      if (!cleanPath.startsWith("/")) {
        cleanPath = "/" + cleanPath;
      }

      // Handle root case: cleanPath might be just "" if we stripped everything
      if (cleanPath === "") cleanPath = "/";

      // Add new prefix
      const newPrefix = getLangPrefix(lang);

      // Construct final path
      // if newPrefix is empty (english), path is just cleanPath
      // if newPrefix is /ja, path is /ja + cleanPath
      let newPath = "";
      if (newPrefix) {
        if (cleanPath === "/") {
          newPath = `${newPrefix}/`;
        } else {
          newPath = `${newPrefix}${cleanPath}`;
        }
      } else {
        newPath = cleanPath;
      }

      // Navigate
      history.push(newPath);

      this.setState({
        language: lang,
        forceUpdate: this.state.forceUpdate + 1,
      });
    }
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes } = this.props;
    const { open, tradeshows } = this.state;
    // Moved pages logic inside Route render to use langPrefix

    let tradeshowLiveNum = 0;
    let today = new Date();
    let thisYear = today.getFullYear();
    for (var i = 0; i < tradeshows.length; i++) {
      var tradeShowDetail = tradeshows[i];
      if (
        new Date(tradeShowDetail.postDate).getFullYear() === thisYear &&
        today >= Date.parse(tradeShowDetail.start) &&
        today <= Date.parse(tradeShowDetail.end)
      ) {
        tradeshowLiveNum++;
      }
    }
    return (
      <MuiThemeProvider theme={theme}>
        <Router>
          {/* Logic for browser detection and first visit redirection. Also handles legacy zh/zh-tw redirects */}
          <Route
            path="/:lang(en|ja|zh-TW|zh-tw|zh)?"
            component={LanguageHandler}
          />

          <ScrollToTop>
            <Route
              render={({ history, location }) => {
                const langPrefix = getLangPrefix(
                  localizationManager.currentLang,
                );

                const pages = [
                  {
                    key: "COMPANY",
                    label: localizationManager.getLocalString("@@company"),
                    link: `${langPrefix}/company`,
                  },
                  {
                    key: "PRODUCT",
                    label: localizationManager.getLocalString("@@products"),
                    link: `${langPrefix}/product`,
                  },
                  {
                    key: "NEWS",
                    label: localizationManager.getLocalString("@@news"),
                    link: `${langPrefix}/news`,
                  },
                  {
                    key: "INQUIRY",
                    label: localizationManager.getLocalString("@@inquiry"),
                    link: `${langPrefix}/inquiry`,
                  },
                  {
                    key: "CONTACT",
                    label: localizationManager.getLocalString("@@contact"),
                    link: `${langPrefix}/contact`,
                  },
                ];

                return (
                  <div className={classes.root}>
                    <AppBar position="fixed">
                      <Toolbar>
                        <IconButton
                          className={classes.menuButton}
                          color="inherit"
                          aria-label="Menu"
                          to={`${langPrefix}/`}
                          component={Link}
                          onClick={this.handleChange}
                        >
                          <Avatar
                            src={logo}
                            alt="LinkChamp Logo"
                            imgProps={{
                              title: "LinkChamp Logo",
                              loading: "lazy",
                            }}
                            className={classes.bigAvatar}
                          />
                        </IconButton>
                        <Typography
                          variant="h6"
                          color="inherit"
                          className={classes.grow}
                        >
                          <Link
                            to={`${langPrefix}/`}
                            style={{
                              color: "inherit",
                              textDecoration: "inherit",
                            }}
                          >
                            LINKCHAMP
                          </Link>
                        </Typography>
                        <Hidden mdUp>
                          <IconButton
                            color="inherit"
                            aria-label="Open drawer"
                            onClick={this.handleDrawerOpen}
                            className={classNames(
                              classes.drawerButton,
                              open && classes.hide,
                            )}
                          >
                            {this.state.cartNum > 0 || tradeshowLiveNum > 0 ? (
                              <Badge color="secondary" variant="dot">
                                <MenuIcon />
                              </Badge>
                            ) : (
                              <MenuIcon />
                            )}
                          </IconButton>
                        </Hidden>
                        <Hidden smDown>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Tabs
                              value={this.state.value}
                              indicatorColor="secondary"
                              textColor="secondary"
                              onChange={this.handleChange}
                            >
                              {pages.map((page) => (
                                <Tab
                                  key={page.key}
                                  label={
                                    page.key.includes("INQUIRY") ? (
                                      <Badge
                                        color="secondary"
                                        badgeContent={this.state.cartNum}
                                      >
                                        {page.label}
                                      </Badge>
                                    ) : page.key.includes("NEWS") &&
                                      tradeshowLiveNum > 0 ? (
                                      <Badge
                                        color="secondary"
                                        badgeContent={tradeshowLiveNum}
                                      >
                                        {page.label}
                                      </Badge>
                                    ) : (
                                      <>{page.label}</>
                                    )
                                  }
                                  to={page.link}
                                  component={Link}
                                  className={classes.tab}
                                />
                              ))}
                            </Tabs>

                            {/* Siblings of Tabs — no more prop leakage to DOM */}
                            <IconButton
                              color="inherit"
                              onClick={this.handleDialogClickOpen}
                            >
                              <SearchIcon />
                            </IconButton>

                            <IconButton
                              color="inherit"
                              onClick={(e) => {
                                e.stopPropagation(); // avoid any parent click handlers
                                this.handleClick(e); // opens language menu
                              }}
                            >
                              <LanguageIcon />
                            </IconButton>

                            <Menu
                              anchorEl={this.state.anchorEl}
                              open={Boolean(this.state.anchorEl)}
                              onClose={() =>
                                this.handleClose(null, history, location)
                              }
                              MenuListProps={{
                                onClick: (e) => e.stopPropagation(),
                              }}
                            >
                              <MenuItem
                                selected={this.state.language === "en"}
                                onClick={() =>
                                  this.handleClose("en", history, location)
                                }
                              >
                                {localizationManager.getLocalString("@@en")}
                              </MenuItem>
                              <MenuItem
                                selected={this.state.language === "ja"}
                                onClick={() =>
                                  this.handleClose("ja", history, location)
                                }
                              >
                                {localizationManager.getLocalString("@@ja")}
                              </MenuItem>
                              <MenuItem
                                selected={this.state.language === "zh-TW"}
                                onClick={() =>
                                  this.handleClose("zh-TW", history, location)
                                }
                              >
                                {localizationManager.getLocalString("@@zh")}
                              </MenuItem>
                            </Menu>
                          </div>
                        </Hidden>
                      </Toolbar>
                    </AppBar>
                    <Dialog
                      open={this.state.dialogOpen}
                      onClose={this.handleDialogClose}
                      aria-labelledby="form-dialog-title"
                    >
                      <DialogTitle id="form-dialog-title">
                        {localizationManager.getLocalString("@@search")}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText>
                          {localizationManager.getLocalString(
                            "@@search_placeholder",
                          )}
                        </DialogContentText>
                        <TextField
                          autoFocus
                          margin="dense"
                          id="name"
                          label={localizationManager.getLocalString(
                            "@@keywords",
                          )}
                          type="product"
                          fullWidth
                          onChange={this.handleDialogTextFieldChange}
                        />
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={this.handleDialogClose}
                          color="secondary"
                        >
                          {localizationManager.getLocalString("@@cancel")}
                        </Button>
                        <Button
                          onClick={() => {
                            window.open(
                              "//" +
                                "google.com/search?q=site:dc-ac.com " +
                                this.state.searchTerm,
                              "_blank",
                            );
                            this.handleDialogClose();
                          }}
                          color="secondary"
                        >
                          {localizationManager.getLocalString("@@search")}
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Drawer
                      className={classes.drawer}
                      anchor="top"
                      open={open}
                      classes={{
                        paper: classes.drawerPaper,
                      }}
                      role="button"
                      onClick={this.handleDrawerClose}
                      onKeyDown={this.handleDrawerClose}
                    >
                      <div className={classes.drawerHeader}>
                        <IconButton
                          className={classes.menuButton}
                          color="inherit"
                          aria-label="Menu"
                          to={`${langPrefix}/`}
                          component={Link}
                          onClick={this.handleChange}
                        >
                          <Avatar
                            src={logo}
                            alt="LinkChamp Logo"
                            imgProps={{
                              title: "LinkChamp Logo",
                              loading: "lazy",
                            }}
                            className={classes.bigAvatar}
                          />
                        </IconButton>
                        <Typography
                          variant="h6"
                          color="inherit"
                          className={classes.grow}
                        >
                          LINKCHAMP
                        </Typography>
                        <IconButton
                          onClick={this.handleDrawerClose}
                          className={classes.drawerButton}
                        >
                          {theme.direction === "ltr" ? (
                            <ExpandLessIcon />
                          ) : (
                            <ExpandMoreIcon />
                          )}
                        </IconButton>
                      </div>
                      <Divider />
                      <List>
                        {pages.map((page) => (
                          <ListItem
                            button
                            key={page.key}
                            to={page.link}
                            component={Link}
                          >
                            {page.key.includes("INQUIRY") ? (
                              <Badge
                                color="secondary"
                                badgeContent={this.state.cartNum}
                              >
                                <ListItemText primary={page.label} />
                              </Badge>
                            ) : page.key.includes("NEWS") &&
                              tradeshowLiveNum > 0 ? (
                              <Badge
                                color="secondary"
                                badgeContent={tradeshowLiveNum}
                              >
                                <ListItemText primary={page.label} />
                              </Badge>
                            ) : (
                              <ListItemText primary={page.label} />
                            )}
                          </ListItem>
                        ))}
                        <IconButton
                          color="inherit"
                          onClick={this.handleDialogClickOpen}
                        >
                          <SearchIcon />
                        </IconButton>

                        <IconButton
                          color="inherit"
                          onClick={(e) => {
                            e.stopPropagation(); // don't let Drawer close
                            this.handleClick(e);
                          }}
                        >
                          <LanguageIcon />
                        </IconButton>

                        <Menu
                          anchorEl={this.state.anchorEl}
                          open={Boolean(this.state.anchorEl)}
                          onClose={() =>
                            this.handleClose(null, history, location)
                          }
                          MenuListProps={{
                            onClick: (e) => e.stopPropagation(),
                          }}
                        >
                          <MenuItem
                            selected={this.state.language === "en"}
                            onClick={() =>
                              this.handleClose("en", history, location)
                            }
                          >
                            {localizationManager.getLocalString("@@en")}
                          </MenuItem>
                          <MenuItem
                            selected={this.state.language === "ja"}
                            onClick={() =>
                              this.handleClose("ja", history, location)
                            }
                          >
                            {localizationManager.getLocalString("@@ja")}
                          </MenuItem>
                          <MenuItem
                            selected={this.state.language === "zh-TW"}
                            onClick={() =>
                              this.handleClose("zh-TW", history, location)
                            }
                          >
                            {localizationManager.getLocalString("@@zh")}
                          </MenuItem>
                        </Menu>
                      </List>
                    </Drawer>
                    <Snackbar
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      open={this.state.isSnackbarOpen}
                      autoHideDuration={6000}
                      onClose={this.handleSnackbarClose}
                      ContentProps={{
                        "aria-describedby": "message-id",
                      }}
                      message={
                        <span id="message-id">
                          {localizationManager.getLocalString(
                            "@@added_to_inquiry_cart",
                          )}
                        </span>
                      }
                      action={[
                        <Button
                          key="undo"
                          color="secondary"
                          size="small"
                          component={Link}
                          to={`${langPrefix}/inquiry`}
                          button="true"
                        >
                          {localizationManager.getLocalString("@@view_cart")}
                        </Button>,
                        <IconButton
                          key="close"
                          aria-label="Close"
                          color="inherit"
                          onClick={this.handleSnackbarClose}
                        >
                          <CloseIcon />
                        </IconButton>,
                      ]}
                    />
                  </div>
                );
              }}
            />
            {/* NOTE: Difference between passing component to Route as prop and wrapping component in render function:
                https://stackoverflow.com/questions/59256109/difference-between-passing-component-to-route-as-prop-and-wrapping-component-in */}
            <Switch>
              {/* Redirect old URLS to new */}
              {redirectURLs.map((url) => (
                <Redirect
                  key={url.old}
                  from={url.old}
                  to={url.new}
                  render={(props) => (
                    <Index
                      {...props}
                      cartCallback={this.cartCallback}
                      cart={this.cart}
                    />
                  )}
                />
              ))}
              <Route
                path={["/", "/:lang(en|ja|zh-TW|zh-tw|zh)/"]}
                exact
                // render={(props) => (
                //   <Index
                //     {...props}
                //     cartCallback={this.cartCallback}
                //     cart={this.cart}
                //   />
                // )}
                /* We need to use render props properly to inject cartCallback. 
                   The previous code was: path="/" exact render={(props) => <Index ... />}
                   The new path is an array.
                */
                render={(props) => (
                  <Index
                    {...props}
                    cartCallback={this.cartCallback}
                    cart={this.cart}
                  />
                )}
              />
              <Route
                path={["/company/", "/:lang(en|ja|zh-TW|zh-tw|zh)/company/"]}
                render={(props) => <Company {...props} />}
              />
              <Route
                path={["/product/", "/:lang(en|ja|zh-TW|zh-tw|zh)/product/"]}
                render={(props) => (
                  <Product
                    {...props}
                    cartCallback={this.cartCallback}
                    cart={this.cart}
                  />
                )}
              />
              <Route
                path={["/news/", "/:lang(en|ja|zh-TW|zh-tw|zh)/news/"]}
                render={(props) => <TradeShow {...props} />}
              />
              <Route
                path={["/articles/", "/:lang(en|ja|zh-TW|zh-tw|zh)/articles/"]}
                exact
                render={(props) => <Articles {...props} />}
              />
              <Route
                path={["/articles/:slug", "/:lang(en|ja|zh-TW|zh-tw|zh)/articles/:slug"]}
                render={(props) => <ArticleDetail {...props} />}
              />
              {/* <Redirect from="/inquiry/" to="/from.htm" component={Inquiry} /> */}
              <Route
                path={["/inquiry/", "/:lang(en|ja|zh-TW|zh-tw|zh)/inquiry/"]}
                render={(props) => (
                  <Inquiry
                    {...props}
                    cartCallback={this.cartCallback}
                    cart={this.cart}
                  />
                )}
              />
              <Route
                path={["/contact/", "/:lang(en|ja|zh-TW|zh-tw|zh)/contact/"]}
                render={(props) => <Contact {...props} />}
              />
              <Route
                path={[
                  "/privacypolicy/",
                  "/:lang(en|ja|zh-TW|zh-tw|zh)/privacypolicy/",
                ]}
                render={(props) => <PrivacyPolicy {...props} />}
              />
              <Route
                path={[
                  "/taiwan-inverter-manufacturer",
                  "/:lang(en|ja|zh-TW|zh-tw|zh)/taiwan-inverter-manufacturer",
                ]}
                render={(props) => <TaiwanInverterManufacturer {...props} />}
              />
              <Route render={(props) => <NotFound {...props} />} />
            </Switch>
            <Footer />
          </ScrollToTop>
        </Router>
      </MuiThemeProvider>
    );
  }
}

LCAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTheme(theme)(withStyles(styles)(LCAppBar));
